import React from "react";

export const CedeHubLogo = () => (
  <svg width="30" height="30" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.00130512 7.46523C0.00130512 4.89932 2.07173 2.82056 4.62447 2.82056H14.642C17.1961 2.82056 19.2652 4.90063 19.2652 7.46523V17.5295C19.2652 20.0955 17.1947 22.1743 14.642 22.1743H4.60092C2.05997 22.1743 0 20.1046 0 17.5519V7.46398L0.00130512 7.46523Z"
      fill="url(#paint0_linear_11905_12972)"
    />
    <path
      d="M1.11948 8.04389C1.11948 5.77474 2.9507 3.93497 5.20934 3.93497H14.0714C16.33 3.93497 18.1613 5.77474 18.1613 8.04389V16.9473C18.1613 19.2165 16.33 21.0562 14.0714 21.0562H5.18845C2.94024 21.0562 1.11816 19.2257 1.11816 16.967V8.04257L1.11948 8.04389Z"
      fill="black"
    />
    <path
      d="M2.22461 8.62831C2.22461 6.6546 3.81664 5.05515 5.7812 5.05515H13.4878C15.4524 5.05515 17.0443 6.6546 17.0443 8.62831V16.3709C17.0443 18.3446 15.4524 19.944 13.4878 19.944H5.76422C3.81011 19.944 2.22592 18.3524 2.22592 16.3879V8.62831H2.22461Z"
      fill="white"
    />
    <path
      d="M8.0088 13.2415C8.73429 11.979 8.52672 10.494 7.54523 9.92478C6.5637 9.35544 5.17992 9.91728 4.45442 11.1798C3.72893 12.4422 3.93645 13.9271 4.91798 14.4965C5.89952 15.0658 7.2833 14.5039 8.0088 13.2415Z"
      fill="black"
    />
    <path
      d="M7.23098 12.099C7.65758 12.099 8.00344 11.7515 8.00344 11.3229C8.00344 10.8943 7.65758 10.5469 7.23098 10.5469C6.80436 10.5469 6.4585 10.8943 6.4585 11.3229C6.4585 11.7515 6.80436 12.099 7.23098 12.099Z"
      fill="white"
    />
    <path
      d="M14.3905 14.5079C15.3719 13.9386 15.5795 12.4537 14.854 11.1912C14.1285 9.92882 12.7447 9.3669 11.7632 9.93624C10.7817 10.5056 10.5741 11.9905 11.2996 13.2529C12.0251 14.5154 13.4089 15.0773 14.3905 14.5079Z"
      fill="black"
    />
    <path
      d="M12.0758 12.1105C12.5024 12.1105 12.8482 11.7631 12.8482 11.3344C12.8482 10.9058 12.5024 10.5584 12.0758 10.5584C11.6491 10.5584 11.3032 10.9058 11.3032 11.3344C11.3032 11.7631 11.6491 12.1105 12.0758 12.1105Z"
      fill="white"
    />
    <path
      d="M9.65718 15.3907C9.65718 15.3907 9.10558 15.3685 8.90821 15.5103C8.71085 15.6521 8.72391 15.8714 8.72391 15.8714C8.72391 15.8714 8.69778 16.096 8.76311 16.2417C8.82852 16.3875 9.21147 16.3625 9.3997 16.6868C9.3997 16.6868 9.57221 16.746 9.65718 16.7289"
      fill="black"
    />
    <path
      d="M9.65088 15.3907C9.65088 15.3907 10.2026 15.3684 10.3999 15.5102C10.5973 15.6521 10.5842 15.8713 10.5842 15.8713C10.5842 15.8713 10.6104 16.0959 10.545 16.2417C10.4797 16.3874 10.0967 16.3625 9.90844 16.6869C9.90844 16.6869 9.73593 16.746 9.65088 16.7289"
      fill="black"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11905_12972"
        x1="56.0417"
        y1="24.3395"
        x2="55.6351"
        y2="-0.964929"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5EA6FF" />
        <stop offset="1" stopColor="#5EA6FF" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);
